<aside class="it-sidebar">
	<div class="it-sidebar-head">
		<div class="it-filter">
			<div class="it-filter-label">Search filter</div>

			<input class="it-filter-input" type="text" placeholder="Filter" [value]="vm.requestSearch" (input)="requestSearchChanged.emit($any($event.target).value)" />
		</div>

		<div class="it-side-row">
			<div class="it-side-row-title">Collections</div>
			<div class="it-side-row-actions">
				<button class="it-sidebtn" type="button" [disabled]="!vm.selectedIntegrationId" (click)="addCollection.emit()">New</button>
				<button class="it-sidebtn" type="button" [disabled]="!vm.activeCollection" (click)="renameCollection.emit()">Rename</button>
				<button class="it-sidebtn danger" type="button" [disabled]="!vm.activeCollection" (click)="deleteCollection.emit()">Delete</button>
			</div>
		</div>

		<dx-select-box class="it-control it-collection-dd" [dataSource]="vm.collections" displayExpr="name" valueExpr="id" [value]="vm.activeCollection?.id || null" [disabled]="!vm.selectedIntegrationId" (onValueChanged)="onCollectionChanged($event)">
		</dx-select-box>

		<div class="it-move-wrap" *ngIf="vm.collections?.length && vm.activeCollection" (dragenter)="onMovePickerDragEnter($event)" (dragover)="onMovePickerDragOver($event)" (dragleave)="onMovePickerDragLeave($event)">

			<div class="it-collection-drop" [class.is-over]="showMovePicker">
				Drop here to move it to a different collection
			</div>

			<div class="it-move-picker" *ngIf="showMovePicker">
				<div class="it-move-picker-title">Move to…</div>

				<div class="it-move-col" *ngFor="let c of vm.collections" [class.is-over]="movePickerOverColId === c.id" [class.is-disabled]="c.id === vm.activeCollection.id" (dragenter)="onMovePickerColDragEnter($event, c.id)" (dragover)="onMovePickerColDragOver($event, c.id)"
					(drop)="onMovePickerColDrop($event, c.id)">
					{{ c.name }}
					<span class="it-move-col-meta" *ngIf="c.id === vm.activeCollection.id">(current)</span>
				</div>
			</div>
		</div>

		<div class="it-side-row">
			<div class="it-side-row-title">Requests</div>
			<div class="it-side-row-actions">
				<button class="it-sidebtn" type="button" [disabled]="!vm.activeCollection" (click)="addRequest.emit()">New</button>
				<button class="it-sidebtn" type="button" [disabled]="!vm.activeRequest" (click)="duplicateRequest.emit()">Duplicate</button>
				<button class="it-sidebtn danger" type="button" [disabled]="!vm.activeRequest" (click)="deleteRequest.emit()">Delete</button>
			</div>
		</div>
	</div>

	<div class="it-side-list">

		<!-- Global results (all collections) when filter has 2+ chars -->
		<ng-container *ngIf="(vm.requestSearch ?? '').trim().length >= 2; else activeCollectionList">

			<button type="button" class="it-reqrow" *ngFor="let x of vm.searchResults" (click)="onNavigate(x.colId, x.reqId)">

				<span class="it-chip" [attr.data-method]="x.method">{{ x.method }}</span>
				<span class="it-reqtext">
					<span class="it-reqname">{{ x.reqName }}</span>
					<span class="it-requl">{{ x.reqUrl }}</span>
					<span class="it-reqmeta">{{ x.colName }}</span>
				</span>
			</button>

			<div class="it-empty" *ngIf="vm.searchResults.length === 0">
				No requests match your filter.
			</div>

		</ng-container>

		<!-- Normal list (active collection + drag/drop) -->
		<ng-template #activeCollectionList>

			<button type="button" class="it-reqrow" *ngFor="let r of vm.filteredRequests" [class.is-active]="vm.activeRequest?.id === r.id" [class.is-dragover]="dragOverReqId === r.id" [class.drop-above]="dragOverReqId === r.id && dragOverReqPos === 'above'" [class.drop-below]="dragOverReqId === r.id && dragOverReqPos === 'below'"
				(click)="onReqClick(r.id)" draggable="true" (dragstart)="onReqDragStart($event, vm.activeCollection?.id!, r.id)" (dragend)="onReqDragEnd()" (dragover)="onReqDragOver($event, r.id)" (dragleave)="onReqDragLeave(r.id)" (drop)="onReqDropOnReq($event, vm.activeCollection?.id!, r.id)">

				<span class="it-chip" [attr.data-method]="r.method">{{ r.method }}</span>
				<span class="it-reqtext">
					<span class="it-reqname">{{ r.name }}</span>
					<span class="it-requl">{{ r.url }}</span>
				</span>
			</button>

			<div class="it-drop-end" *ngIf="vm.activeCollection && vm.filteredRequests.length > 0" [class.is-over]="dragOverListEnd" (dragover)="onReqListEndDragOver($event)" (dragleave)="onReqListEndDragLeave()" (drop)="onReqListEndDrop($event, vm.activeCollection.id)"
				aria-hidden="true"></div>

			<div class="it-empty" *ngIf="vm.activeCollection && vm.filteredRequests.length === 0">
				No requests match your filter.
			</div>

			<div class="it-empty" *ngIf="!vm.activeCollection">
				Select or create a collection.
			</div>

		</ng-template>
	</div>
</aside>
